import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { CONTEXT } from '../../config';
import styles from './OneColumnRank.module.less';
import Button from '../../components/Button/Button';
import ApkButton from '../../components/Button/Button';
import { logging, logPostInfo } from '../../actions/log';
import { sortSoftsByLocalSoftInit } from '../../utils/utils';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(cardData => {
  const { data, logInfo } = cardData;
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const showSize = 5;
  const [showDataColumn1, setShowDataColumn1] = useState({});
  const LOG_ACTION_SOURCE = {
    action: `${logInfo.tag}_Rank_Hotweek`,
    source: `${logInfo.tag}_Rank_1Column`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
      });
    }
  }, [inView]);

  const handleSoftCard = useCallback(
    soft => {
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.action,
          label: '',
          param2: {
            source: showDataColumn1.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: soft.bizInfo,
        }),
      );
      dispatch(
        logPostInfo({
          source_p: showDataColumn1.source,
          source_pp: logInfoData.source_p,
        }),
      );
    },
    [dispatch, logInfoData, showDataColumn1],
  );

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList && data.dataList.length > 0) {
      if (data.dataList[0] && data.dataList[0].apps && data.dataList[0].apps.length > 0) {
        setShowDataColumn1({
          ...data.dataList[0],
          showSofts: sortSoftsByLocalSoftInit(data.dataList[0].apps || [], localSoftsInit),
          source: `${LOG_ACTION_SOURCE.source}||${data.dataList[0].code}`,
        });
      }
    }
  }, [localSoftsInit]);

  return showDataColumn1 && showDataColumn1.showSofts && showDataColumn1.showSofts.length > 0 ? (
    <div className={styles.card} ref={ref}>
      <div className="card_hot_header">
        <div className="hot_header_icon" />
        <div className="hot_header_title">{showDataColumn1.name}</div>
      </div>
      <div className="hot_list">
        {showDataColumn1.showSofts.slice(0, showSize).map((item, i) => (
          <div className="hot_list_item" key={i}>
            <div className="item_logo">
              <img className="item_img" src={item.logoFile} alt="banner" />
              {item.androidType === '1' && <div className="item_alogo" />}
            </div>
            <Link
              className="item_name_link"
              to={{
                pathname:
                  item.androidType === '1'
                    ? `${CONTEXT}/adetail/${item.packageName}/${item.versionCode}/${item.bizInfo ||
                        '{}'}`
                    : `${CONTEXT}/detail/soft/${item.softID}/${item.bizInfo || '{}'}`,
              }}
              onClick={() => {
                handleSoftCard(item);
              }}
              title={item.softName}
            >
              {item.softName}
            </Link>
            {item.androidType === '1' ? (
              <ApkButton
                soft={item}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                logInfo={{ source: showDataColumn1.source }}
              />
            ) : (
              <Button
                soft={item}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                logInfo={{ source: showDataColumn1.source }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ''
  );
});
